import { render, staticRenderFns } from "./set-stock-inquiry.vue?vue&type=template&id=0ba0d9f0&"
import script from "./set-stock-inquiry.vue?vue&type=script&lang=js&"
export * from "./set-stock-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports